import { Dialog as BaseDialog } from '@base-ui/react/dialog'

import { cn } from '@gto/ui/cn'

export const Backdrop = ({ className, ...props }: BaseDialog.Backdrop.Props) => {
  return (
    <BaseDialog.Backdrop
      // Always render the backdrop, even for nested dialogs.
      // Base UI suppresses nested backdrops by default, but we need them
      // for click-outside dismissal to work on nested dialogs.
      forceRender
      className={cn('fixed inset-0 z-modal bg-black/50', className)}
      {...props}
    />
  )
}
